import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FormikProps } from 'formik';
import { useDispatch, useSelector } from 'react-redux';

import { ConsultancyInitiationForm } from 'common/forms';
import { ConsultancyInitiationFormValues } from 'common/models/Forms';

import { QuestionTitle, PageControls } from '../../../../components';
import {
  selectProtocolInitiation,
  setProtocolInitiationValuesAction,
  selectStrategy,
  selectInvestingHazard,
} from '../../../../ducks';
import { useFormStepContinueRef } from '../../../../hooks/useFormStepContinueRef';
import { FeatureProps } from '../../../../index';

export default function ProtocolInitiationFeature({ isPrivileged }: FeatureProps) {
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const initialValues = useSelector(selectProtocolInitiation);
  const strategy = useSelector(selectStrategy);
  const hazard = useSelector(selectInvestingHazard);

  const { bindFormik, continueWithSoftValidation, showSoftContinueHint } =
    useFormStepContinueRef<ConsultancyInitiationFormValues>();

  function handleBackClick() {
    navigate(`/form/${id}/protocol/goals`);
  }

  async function handleContinueClick() {
    await continueWithSoftValidation((values) => {
      handleSubmit(values);
    });
  }

  function bindSubmit(formik: FormikProps<ConsultancyInitiationFormValues>) {
    bindFormik(formik);
  }

  function handleSubmit(values: ConsultancyInitiationFormValues) {
    if (!isPrivileged) {
      dispatch(setProtocolInitiationValuesAction(values));
    }
    navigate(`/form/${id}/protocol/customer-statement`);
  }

  return (
    <>
      <QuestionTitle>{t('protocolFeature.initiation')}</QuestionTitle>
      <ConsultancyInitiationForm
        initialValues={initialValues || undefined}
        strategy={strategy}
        hazard={hazard}
        bindSubmit={bindSubmit}
        onSubmit={handleSubmit}
      />
      <PageControls softContinueHint={showSoftContinueHint} onBack={handleBackClick} onContinue={handleContinueClick} />
    </>
  );
}
